import { GROUPS_PERMISSIONS,USERS_PERMISSIONS } from "../lib/constants/actions";



export const getGroupPermission = (data) => {
    return {
        type: GROUPS_PERMISSIONS.GET_PERMISSIONS,
        payload: data
    }
}

export const getGroupPermissionSuccess = (data) => {
    return {
        type: GROUPS_PERMISSIONS.GET_PERMISSIONS_SUCCESS,
        payload: data
    }
}

export const updateGroupPermission = (data) => {
    return {
        type: GROUPS_PERMISSIONS.UPDATE_PERMISSIONS,
        payload: data
    }
}

export const updateGroupPermissionSuccess = (data) => {
    return {
        type: GROUPS_PERMISSIONS.UPDATE_PERMISSIONS_SUCCESS,
        payload: data
    }
}

//


export const getUserPermission = (data) => {
    return {
        type: USERS_PERMISSIONS.GET_USER_PERMISSIONS,
        payload: data
    }
}

export const getUserPermissionSuccess = (data) => {
    return {
        type: USERS_PERMISSIONS.GET_USER_PERMISSIONS_SUCCESS,
        payload: data
    }
}

export const updateUserPermission = (data) => {
    return {
        type: USERS_PERMISSIONS.UPDATE_USER_PERMISSIONS,
        payload: data
    }
}

export const updateUserPermissionSuccess = (data) => {
    return {
        type: USERS_PERMISSIONS.UPDATE_USER_PERMISSIONS_SUCCESS,
        payload: data
    }
}










